/**
 * Dropdown of relative-date operators (Today, Last Week, Next Quarter,
 * etc.) sourced from the operator catalog.
 *
 * The catalog returns the legacy 25+ EACReportDateTimeOperator values
 * via `operatorCatalog.date` and `operatorCatalog.datetime`; this
 * component prefers `datetime` if available.
 */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';
import { type OperatorCatalogResponse } from '../../../lib/api/reporting';

interface DateOperatorSelectProps {
  value: string;
  onChange: (next: string) => void;
  catalog: OperatorCatalogResponse | null;
  /** Use 'datetime' (default) or 'date' bucket from catalog. */
  variant?: 'date' | 'datetime';
  className?: string;
}

export function DateOperatorSelect({
  value,
  onChange,
  catalog,
  variant = 'datetime',
  className,
}: DateOperatorSelectProps) {
  const list = catalog
    ? (variant === 'date' ? catalog.date : catalog.datetime) || catalog.date || []
    : [];

  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger className={`h-8 text-xs ${className || ''}`}>
        <SelectValue placeholder="Select date operator" />
      </SelectTrigger>
      <SelectContent>
        {list.length === 0 ? (
          <SelectItem value="none" disabled>No operators loaded</SelectItem>
        ) : (
          list.map((op) => (
            <SelectItem key={op.key} value={op.key}>
              {op.label}
            </SelectItem>
          ))
        )}
      </SelectContent>
    </Select>
  );
}
